import homeImg from "../../assests/images/home/home.jpg";
import mandalCommitteeImg from "../../assests/images/home/group.jpg";
import settingImg from "../../assests/images/home/adminsettings.jpg";
import enquiryImg from "../../assests/images/home/enquiry.jpg";
import testimonialsImg from "../../assests/images/home/testimonials.jpg";
import { Link } from "react-router-dom";

function Home() {
  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="2">
              Welcome To Maratha Hitwardhak Mandal Adminstration Panel
            </th>
          </tr>
          <tr>
            <td className="frm" style={{ fontSize: "15", fontWeight: "bold" }}>
              <Link to="/admin/committee" style={{ textDecoration: "none" }}>
                <img
                  src={mandalCommitteeImg}
                  align="middle"
                  width="100"
                  height="100"
                  border="0"
                />
                <span>Mandal Committee</span>
              </Link>
            </td>
            <td
              className="frm"
              style={{ fontSize: "15", fontWeight: "bold" }}
              colSpan="4"
            >
              <Link to="/admin/sitesetting" style={{ textDecoration: "none" }}>
                <img
                  src={settingImg}
                  align="middle"
                  width="100"
                  height="100"
                  border="0"
                />
                <span>Account Settings</span>
              </Link>
            </td>
          </tr>
          <tr>
            <td className="frm" style={{ fontSize: "15", fontWeight: "bold" }}>
              <Link to="/admin/photos" style={{ textDecoration: "none" }}>
                <img
                  src={enquiryImg}
                  align="middle"
                  width="100"
                  height="100"
                  border="0"
                />
                <span>Photo Gallery</span>
              </Link>
            </td>

            <td className="frm" style={{ fontSize: "15", fontWeight: "bold" }}>
              <Link to="/admin/ahaval" style={{ textDecoration: "none" }}>
                <img
                  src={testimonialsImg}
                  align="middle"
                  width="100"
                  height="100"
                  border="0"
                />
                <span>Ahaval Activity</span>
              </Link>
            </td>
          </tr>

          <tr>
            <td className="frm" style={{ fontSize: "15", fontWeight: "bold" }}>
              <Link to="/admin/phototype" style={{ textDecoration: "none" }}>
                <img
                  src={enquiryImg}
                  align="middle"
                  width="100"
                  height="100"
                  border="0"
                />
                <span>Photo Type</span>
              </Link>
            </td>
            </tr>
        </tbody>
      </table>
    </>
  );

  return contents;
}

export default Home;
